import { render, staticRenderFns } from "./tipoSolicitud.vue?vue&type=template&id=48032b37&scoped=true"
import script from "./tipoSolicitud.vue?vue&type=script&lang=js"
export * from "./tipoSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48032b37",
  null
  
)

export default component.exports